export default "__VITE_ASSET__COesb$Kz__"